import { h } from "preact";
import { RoutableProps } from "preact-router";
import "./styles.scss";
import { Snackbar, SnackbarShowCommand } from "../../../components/Snackbar";
import { useCommand } from "../../../hooks";
import { manufacturingConfigurations } from "../../../App";
import { lunaEMG } from "../../../data/serialNumberSearchExecs";
import { ProductLabelReprint } from "../../../components/ProductLabelReprint";

export function LunaEMGReprint(props: RoutableProps) {
    const showSnackbar = useCommand<SnackbarShowCommand>();

    return (
        <div class="luna-emg-reprint-page">
            <Snackbar doShow={showSnackbar} />
            <ProductLabelReprint
                showSnackbar={showSnackbar}
                configurations={manufacturingConfigurations["LunaEMG"]}
                execs={[lunaEMG.execs.elementGtinLot8DateRegexPlain, lunaEMG.execs.elementSerialRegexPlain]}
                scanExecs={[
                    lunaEMG.execs.elementSerialRegex,
                    lunaEMG.execs.elementSerialRegexGs1,
                    lunaEMG.execs.elementGtinLot8DateRegexGs1,
                    lunaEMG.execs.elementGtinLotRegexGs1,
                    lunaEMG.execs.elementSerialRegexPlain,
                ]}
            />
        </div>
    );
}
